
const {CopyToClipboard} = require('./Component');


CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;
